import React, { useEffect, useState } from 'react';
import '../MiZona/MiZona.css';
import { comunicarAplazamiento, getComunicado } from '../../services/revisarAplazamientoService';
import { formatearFecha } from '../MiZona/estadosPartido';

const Personas = ({ lista }) => (
  <ul>
    {lista.map((d) => (
      <li key={d.jugadorId}>{d.nombre} — {d.email ?? <span className="msg-error">sin correo registrado</span>}</li>
    ))}
  </ul>
);

// «Comunicar»: vista previa del correo (plantilla de la BD) al contrincante, con
// copia a quien pidió el aplazamiento. Destinatarios y texto los calcula el
// servidor. Enviar pide una confirmación Sí/No; si ya se comunicó, es un reenvío.
export default function ModalComunicar({ solicitudId, onCerrar, onEnviado }) {
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);
  const [confirmando, setConfirmando] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null);

  useEffect(() => {
    getComunicado(solicitudId).then(setInfo).catch((err) => setError(err.message || 'No se pudo cargar el correo.'));
  }, [solicitudId]);

  const enviar = async () => {
    setEnviando(true);
    setError(null);
    try {
      setResultado(await comunicarAplazamiento(solicitudId, Boolean(info?.comunicadoEn)));
      onEnviado();
    } catch (err) {
      setError(err.message || 'No se pudo enviar el correo.');
      setConfirmando(false);
    } finally {
      setEnviando(false);
    }
  };

  const hayDestino = info ? info.para.some((d) => d.email) : false;

  return (
    <div className="mz-modal-fondo">
      <div className="mz-modal" role="dialog" aria-modal="true" aria-labelledby="ra-comunicar-titulo">
        <h3 id="ra-comunicar-titulo">Comunicar aplazamiento</h3>
        {resultado ? (
          <>
            <p role="status">Correo enviado a: {resultado.enviados.join(', ')}. Copia a: {resultado.copia.join(', ')}.</p>
            {resultado.sinCorreo.length > 0 && (
              <p className="msg-error">Sin correo registrado (no lo han recibido): {resultado.sinCorreo.join(', ')}.</p>
            )}
          </>
        ) : (
          <>
            {!info && !error && <p>Cargando…</p>}
            {info && (
              <>
                <p><strong>Para (contrincante):</strong></p>
                <Personas lista={info.para} />
                <p><strong>CC (quien pidió el aplazamiento):</strong></p>
                <Personas lista={info.cc} />
                {info.ccComite && <p><strong>CC (comité):</strong> {info.ccComite}</p>}
                <p><strong>Asunto:</strong> {info.asunto}</p>
                <pre className="ra-cuerpo-correo">{info.texto}</pre>
                {info.comunicadoEn && (
                  <p className="ap-banner" role="note">
                    Ya se comunicó el {formatearFecha(String(info.comunicadoEn).slice(0, 10))}. ¿Quieres reenviarlo?
                  </p>
                )}
                {confirmando && <p role="alert"><strong>¿Confirmas el envío del correo?</strong></p>}
              </>
            )}
          </>
        )}
        {error && <p className="msg-error" role="alert">{error}</p>}
        <div className="mz-modal-acciones">
          {confirmando && !resultado ? (
            <>
              <button type="button" className="btn btn-secondary" disabled={enviando} onClick={() => setConfirmando(false)}>No</button>
              <button type="button" className="btn btn-success" disabled={enviando} onClick={enviar}>{enviando ? 'Enviando…' : 'Sí'}</button>
            </>
          ) : (
            <>
              <button type="button" className="btn btn-secondary" onClick={onCerrar}>{resultado ? 'Cerrar' : 'Cancelar'}</button>
              {!resultado && (
                <button type="button" className="btn btn-success" disabled={!hayDestino} onClick={() => setConfirmando(true)}>
                  {info?.comunicadoEn ? 'Reenviar' : 'Enviar'}
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
